// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"108":"575c53056d5e1eda","3133":"9ee8519606e7f5e8"}[chunkId] + ".css";
};